// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const TargetOverride = lazy(
  () => import('pages/targetOverride/TargetOverride')
);

const TargetOverrideRoute = (
  <Route path={routeName.targetOverride}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.TARGET_OVERRIDE_VIEW}>
          <Suspense fallback={<Loading />}>
            <TargetOverride />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default TargetOverrideRoute;
